import { SSO } from "../models";

export type SSOActions =
  { type: SSOAction.DeleteSSO } |
  { type: SSOAction.DeleteSSOFailure, error: string } |
  { type: SSOAction.DeleteSSOSuccess } |
  { type: SSOAction.LoadSSO, clientId: number } |
  { type: SSOAction.LoadSSOFailure, error: string } |
  { type: SSOAction.LoadSSOSuccess, sso: SSO } |
  { type: SSOAction.MetadataDownloadBegin } |
  { type: SSOAction.MetadataDownloadEnd } |
  { type: SSOAction.SaveSSO } |
  { type: SSOAction.SaveSSOFailure, error: string } |
  { type: SSOAction.SaveSSOSuccess, sso: SSO } |
  { type: SSOAction.UpdateSSO, propertyKey: keyof SSO, propertyValue: boolean | string };

export enum SSOAction {
  DeleteSSO = "DELETE_SSO",
  DeleteSSOFailure = "DELETE_SSO_FAILURE",
  DeleteSSOSuccess = "DELETE_SSO_SUCCESS",
  LoadSSO = "LOAD_SSO",
  LoadSSOFailure = "LOAD_SSO_FAILURE",
  LoadSSOSuccess = "LOAD_SSO_SUCCESS",
  MetadataDownloadBegin = "METADATA_DOWNLOAD_BEGIN",
  MetadataDownloadEnd = "METADATA_DOWNLOAD_END",
  SaveSSO = "SAVE_SSO",
  SaveSSOFailure = "SAVE_SSO_FAILURE",
  SaveSSOSuccess = "SAVE_SSO_SUCCESS",
  UpdateSSO = "UPDATE_SSO",
}
